import React from 'react';

/**
 * Fine-tune head position/size on the card (percent shifts relative to default anchor).
 */
export default function HeadPlacementTweaks({
  shiftX,
  shiftY,
  sizePct,
  onShiftX,
  onShiftY,
  onSizePct,
  onReset,
}) {
  return (
    <div className="pcg-head-tweak-panel">
      <p className="pcg-head-tweak-title">Fine-tune head on card</p>
      <p className="pcg-head-tweak-hint">
        Move and resize until your face lines up with the jersey. On a phone or tablet, you can also drag your head
        directly on the card preview, and pinch with two fingers to resize.
      </p>

      <div className="pcg-head-tweak-field">
        <label htmlFor="pcg-head-shift-x">Left / right</label>
        <div className="pcg-head-tweak-row">
          <input
            id="pcg-head-shift-x"
            type="range"
            min={-10}
            max={10}
            step={0.5}
            value={shiftX}
            onChange={(e) => onShiftX(Number(e.target.value))}
            className="pcg-head-tweak-range"
          />
          <span className="pcg-head-tweak-val">{shiftX > 0 ? `+${shiftX}` : shiftX}</span>
        </div>
      </div>

      <div className="pcg-head-tweak-field">
        <label htmlFor="pcg-head-shift-y">Up / down</label>
        <div className="pcg-head-tweak-row">
          <input
            id="pcg-head-shift-y"
            type="range"
            min={-8}
            max={8}
            step={0.5}
            value={shiftY}
            onChange={(e) => onShiftY(Number(e.target.value))}
            className="pcg-head-tweak-range"
          />
          <span className="pcg-head-tweak-val">{shiftY > 0 ? `+${shiftY}` : shiftY}</span>
        </div>
      </div>

      <div className="pcg-head-tweak-field">
        <label htmlFor="pcg-head-size">Size</label>
        <div className="pcg-head-tweak-row">
          <input
            id="pcg-head-size"
            type="range"
            min={75}
            max={130}
            step={1}
            value={sizePct}
            onChange={(e) => onSizePct(Number(e.target.value))}
            className="pcg-head-tweak-range"
          />
          <span className="pcg-head-tweak-val">{sizePct}%</span>
        </div>
      </div>

      <button type="button" className="pcg-head-tweak-reset" onClick={onReset}>
        Reset placement
      </button>
    </div>
  );
}
